import { JSONSchema7 } from 'json-schema';
import { types as commonTypes, customSchemas } from '@sitebuilder/common';
import DailyPriceWrapper from './DailyPriceWrapper';

const schema: JSONSchema7 = {
    title: 'Daily Price',
    type: 'object',
    required: [],
    properties: {
        styles: {
            type: 'string',
            description: 'Add styling',
            default: '',
        },
        ...customSchemas.textSchema.TextSchema.schema,
        ...customSchemas.styleSchema.StyleSchema.schema,
        ...customSchemas.layoutSchema.LayoutSchema.schema,
        date: {
            type: 'string',
            description: 'Enter date here',
            default: '',
            title: 'Date',
        },
        price: {
            type: 'string',
            description: 'Enter price here',
            default: '',
            title: 'Price',
        },
        priceChange: {
            type: 'string',
            description: 'Enter price changes here',
            default: '',
            title: 'Price change',
        },
        percentageChange: {
            type: 'string',
            description: 'Enter percentage change here',
            default: '',
            title: 'Percentage change',
        },
        showIcon: {
            type: 'boolean',
            enum: [true, false],
            description: 'Show daily price icons',
            default: false,
            title: 'Add Icons',
        },
    },
    dependencies: {
        showIcon: {
            oneOf: [
                {
                    properties: {
                        showIcon: { enum: [true] },
                        percentageUpIcon: {
                            type: 'string',
                            title: 'Percentage up icon',
                        },
                        percentageDownIcon: {
                            type: 'string',
                            title: 'Percentage down icon',
                        },
                        iconPosition: {
                            type: 'string',
                            title: 'Icon Position',
                            enum: ['Right', 'Left'],
                            default: 'Left',
                        },
                    },
                    required: ['percentageUpIcon', 'percentageDownIcon'],
                },
            ],
        },
        ...customSchemas.layoutSchema.LayoutSchema.dependencies,
    },
};

const groups = [
    {
        'Style Editor': ['styles'],
        ...customSchemas.textSchema.TextSchema.group,
        ...customSchemas.styleSchema.StyleSchema.group,
        ...customSchemas.layoutSchema.LayoutSchema.group,
        Values: [
            'date',
            'price',
            'priceChange',
            'percentageChange',
            'showIcon',
            'percentageUpIcon',
            'percentageDownIcon',
            'iconPosition',
        ],
    },
];

const TextWidget: commonTypes.IWidget = {
    schema,
    uiSchema: {
        'ui:groups': groups,
        ...customSchemas.textSchema.TextSchema.uiSchema,
        ...customSchemas.styleSchema.StyleSchema.uiSchema,
        ...customSchemas.layoutSchema.LayoutSchema.uiSchema,
        date: {
            'ui:widget': 'ResourcePicker',
        },
        price: {
            'ui:widget': 'ResourcePicker',
        },
        priceChange: {
            'ui:widget': 'ResourcePicker',
        },
        percentageChange: {
            'ui:widget': 'ResourcePicker',
        },
        percentageUpIcon: {
            'ui:widget': 'ResourcePicker',
        },
        percentageDownIcon: {
            'ui:widget': 'ResourcePicker',
        },
        iconPosition: {
            'ui:widget': 'CustomSelect',
        },
        showIcon: {
            'ui:widget': 'CustomCheckbox',
        },
        styles: {
            'ui:widget': 'CSSEditor',
        },
    },
    templateView: DailyPriceWrapper,
    id: 'DailyPrice',
    group: 'component',
    contentPlaceHolders: ['children'],
    initialData: () => ({}),
};

export default TextWidget;
